import { __extends } from "tslib";
import { ValueObject } from '../../base/ddd-types/value-object';
var DocPrivilege = /** @class */ (function (_super) {
    __extends(DocPrivilege, _super);
    function DocPrivilege(jsonObj) {
        var _this = _super.call(this) || this;
        _this.canAbout = false;
        _this.canHighLightTitle = false;
        _this.canPersonalityLike = false;
        _this.canInvisibleVisit = false;
        _this.canViewRangePrivilege = false;
        _this.canNotice = false;
        _this.canAssociateDoc = false;
        _this.canMultiEdit = false;
        _this.canCache = false;
        _this.canUploadAttachment = false;
        _this.canExportOnline = false;
        _this.canAiExport = false;
        _this.canAddUser = false;
        _this.canAnnotate = false;
        _this.canComment = false;
        _this.canCopy = false;
        _this.canCopyDoc = false;
        _this.canEdit = false;
        _this.canEditTitle = false;
        _this.canHistory = false;
        _this.canLinkExp = false;
        _this.canPrint = false;
        _this.canRead = false;
        _this.canSearch = false;
        _this.canShare = false;
        _this.canSpitSlot = false;
        _this.canTranslate = false;
        _this.canViewImage = false;
        _this.canWatermark = false;
        _this.isPrivilegeExpired = false;
        _this.canApplyEdit = false;
        _this.isAuth = false;
        _this.canPublish = false;
        _this.canSetRange = false;
        _this.canEditTab = false;
        _this.canExport = false;
        _this.canSaveTemplate = false;
        _this.canEditCollab = false;
        _this.canViewCollab = false;
        _this.canInviteMember = false;
        _this.isAdmin = false;
        _this.canViewPrivSetting = false;
        _this.canEditPrivSetting = false;
        _this.canSetInternalAccess = false;
        _this.canSetExternalAccess = false;
        _this.canSetSecuritySetting = false;
        _this.canInviteSpecialDepts = false;
        _this.canSearchUser = false;
        _this.canFilterUser = false;
        _this.canForbidViewerComment = false;
        _this.canForbidViewerCopyDoc = false;
        _this.canTransfer = false;
        _this.canSetEnterRule = false;
        _this.canDelete = false;
        _this.canCreateFile = false;
        _this.canCreateFolder = false;
        _this.canFill = false;
        _this.canViewBrowsingHistory = false;
        _this.canSetRangePrivilege = false;
        _this.canExit = false;
        _this.canDeleteAbsolutely = false;
        _this.canRestore = false;
        _this.canMove = false;
        _this.canEditForm = false;
        _this.canCopyOut = false;
        _this.canRestoreInherit = false;
        _this.canCollect = true;
        _this.canQuickAccess = false;
        _this.canSearchDoc = false;
        _this.canOffline = false;
        _this.canViewMemberPanel = true;
        _this.canDenoteShare = false;
        _this.canUseAiAssistant = false;
        _this.canAddRevision = false;
        _this.canRevert = false;
        _this.jsonObj2Class(jsonObj);
        return _this;
    }
    Object.defineProperty(DocPrivilege.prototype, "canFeedback", {
        /**
         * @deprecated use canSpitSlot
         */
        get: function () {
            return this.canSpitSlot;
        },
        enumerable: false,
        configurable: true
    });
    return DocPrivilege;
}(ValueObject));
export { DocPrivilege };
